<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('edu_programs.semester')" lazy>
              <semester/>
            </b-tab>
            <b-tab :title="$t('edu_programs.assign_courses')" lazy>
              <assign-courses />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('edu_programs.assign_teachers')" lazy>
              <assign-teachers />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('edu_courses.CoursePlan')" lazy>
              <course-plan-vue />
            </b-tab>
             <b-tab   :title="$t('edu_programs.assign_official_exams')" lazy>
              <assign-official-exams />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('discussions.discussions')" lazy>
              <discussions />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('edu_programs.publishing_settings')" lazy>
              <add-starting-point />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
  <!-- end of row -->
</template>

<script>
import Discussions from "../Discussions/components/DataTable.vue";
import AddStartingPoint from "./components/AddStartingPoint.vue";
import AssignCourses from "./components/AssignCourses.vue";
import AssignOfficialExams from "./components/AssignOfficialExams.vue";
import AssignTeachers from "./components/AssignTeachers.vue";
import Semester  from "./components/Semester.vue";
import CoursePlanVue from './CoursePlan.vue';
 
export default {
  name: "EduProgramsIndex",
  components: {
    AssignTeachers,
    AssignCourses,
    AssignOfficialExams,
    Discussions,
    AddStartingPoint,
    Semester,
    CoursePlanVue
  },
  data() {
    return {
      newItem: {},
      tab: 0,
    };
  },
  methods: {},
};
</script>
